import { useState, useEffect } from 'react';

const NAVIGATION_BLOCK_KEY = 'timer_navigation_block_enabled';

const useNavigationBlockPreference = () => {
  const [navigationBlock, setNavigationBlock] = useState(() => {
    try {
      const stored = localStorage.getItem(NAVIGATION_BLOCK_KEY);
      return stored !== null ? JSON.parse(stored) : true; // Default to true
    } catch (error) {
      console.warn('Failed to load navigation block preference:', error);
      return true; // Default to true if localStorage fails
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(NAVIGATION_BLOCK_KEY, JSON.stringify(navigationBlock));
    } catch (error) {
      console.warn('Failed to save navigation block preference:', error);
    }
  }, [navigationBlock]);

  return [navigationBlock, setNavigationBlock];
};

export default useNavigationBlockPreference;
